module.exports = __webpack_public_path__ + "img/wallet.e103f6ab.svg";